import React, { Component } from 'react';
import PropTypes from 'prop-types';
import authStorage from '../../../storages/mobx/authStorage';
import twitterAuth from '../../providers/twitterAuth';

class GithubAuthButton extends Component {
  render() {
    return (
      <button
        className="btn social-btn btn-github d-inline-block"
        type="button"
        onClick={() => twitterAuth(authStorage.setCredientials, authStorage.processError)}
      >
        <i className="fa fa-github" />
      </button>
    );
  }
}

GithubAuthButton.propTypes = {};

export default GithubAuthButton;
